import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '@/shared/ui';
import type { DeleteRequest } from './chat-lib';

export const DeleteDialog: React.FC<{
  request: DeleteRequest | null;
  deleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}> = ({ request, deleting, onConfirm, onClose }) => (
  <Dialog open={request !== null} onOpenChange={(open) => !open && onClose()}>
    <DialogContent>
      <DialogTitle>
        {request?.kind === 'attachment'
          ? 'Удалить вложение?'
          : request && request.messageIds.length + request.attachments.length > 1
            ? `Удалить выбранное (${request.messageIds.length + request.attachments.length})?`
            : request && request.attachments.length === 1
              ? 'Удалить вложение?'
              : 'Удалить сообщение?'}
      </DialogTitle>
      <DialogDescription>
        {request?.kind === 'attachment'
          ? 'Файл будет удалён у всех участников чата. Если в сообщении больше ничего нет, оно будет удалено целиком.'
          : 'Сообщения будут удалены у всех участников чата. Это действие нельзя отменить.'}
      </DialogDescription>
      <DialogFooter>
        <DialogClose render={<Button variant="ghost">Отмена</Button>} />
        <Button variant="destructive" onClick={onConfirm} disabled={deleting}>
          {deleting ? 'Удаление...' : 'Удалить'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
